'use client'

import { createContext, ReactNode, useEffect, useState } from 'react'
import { initFirebase } from 'firebase';
import { firebaseConfig } from "@/const";

export const FirebaseContext = createContext<Partial<{firebaseIsReady: boolean}>>({});

export function FirebaseProvider({
  children,
}: {
  children: ReactNode
}) {
  const [firebaseIsReady, setFirebaseIsReady] = useState(false);
  useEffect(() => {
    // @ts-ignore
    initFirebase(process.env.NEXT_PUBLIC_ENV, firebaseConfig).then(() => {
      setFirebaseIsReady(true);
    });
  }, [])
  return (
    <FirebaseContext.Provider value={{firebaseIsReady}}>
      {children}
    </FirebaseContext.Provider>
  )
  
}